/**
 * Whether the post-import admin selection dialog makes sense for the publisher: only when there are at least two
 * guarantors to choose the admin from (RECEK-75667). While the publisher is still loading (undefined) the dialog
 * is not shown either, so it never flashes up for a publisher that turns out not to need it.
 */
export var needsAdminResolution = function (guarantors) { var _a; return ((_a = guarantors === null || guarantors === void 0 ? void 0 : guarantors.length) !== null && _a !== void 0 ? _a : 0) > 1; };
